import React from 'react'
import Instagram from '../../assets/icons/instagram';
import Youtube from '../../assets/icons/youtube'
import Github from '../../assets/icons/github'
import Linkind from '../../assets/icons/linkind'
import Behance from '../../assets/icons/behance'

function SocialMediaLinks(){
    return (
        <div className='flex flex-row justify-around mt-5 '>
            <Youtube />
            <Instagram />
            <Github />
            <Behance />
            <Linkind />
        </div>
    )
} 

export default SocialMediaLinks;